export const LOGIN_USER_PENDING   = 'LOGIN_USER_PENDING'
export const LOGIN_USER_FULFILLED = 'LOGIN_USER_FULFILLED'
export const LOGOUT_USER          = 'LOGOUT_USER'

export const FETCH_USER_DETAILS_PENDING   = 'FETCH_USER_DETAILS_PENDING'
export const FETCH_USER_DETAILS_FULFILLED = 'FETCH_USER_DETAILS_FULFILLED'
export const FETCH_USER_DETAILS_REJECTED  = 'FETCH_USER_DETAILS_REJECTED'
export const FETCH_USER_DETAILS_DENIED    = 'FETCH_USER_DETAILS_DENIED'
